import { Alert, AlertTitle, Box, Snackbar } from '@mui/material';
import { AlertSnackbarPropsType } from './AlertSnackbar.types';

export const AlertSnackbar = (props: AlertSnackbarPropsType) => {
  const { open, handleClose, text, color = 'error', title, isCenter = false } = props;

  return (
    <Snackbar
      sx={{ top: isCenter ? '50% !important' : '64px !important' }}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      open={open}
      autoHideDuration={6000}
      onClose={handleClose}
    >
      <Alert onClose={handleClose} severity={color}>
        <Box minWidth={300} textAlign='center'>
          {title && <AlertTitle>{title}</AlertTitle>}
          {text}
        </Box>
      </Alert>
    </Snackbar>
  );
};
